import React from 'react';
import CartElementCheckout from "./CartElementCheckout";
import {formatCartElementDate, dateStringToUrlString} from "../../utils/dateTimeUtils";
import { Plural, Trans, useLingui } from '@lingui/react/macro';
import { isTacActivity, TAC_TEMPLATE_TYPES } from '../../constants/tacConstants';

function CartElementTacCheckout(props) {
    const entry = props.entry;
    const nrGuests = entry.nrAdults + entry.nrChildren;
    const isActivity = isTacActivity(entry.serviceProfileTemplateType);

    const {t} = useLingui();

    return (
        <CartElementCheckout
            name={entry.name}
            imageReference={entry.serviceProfileId}
            linkTo={{ pathname: `/tac/restaurants/${dateStringToUrlString(entry.date)}${isActivity ? `/${TAC_TEMPLATE_TYPES.ACTIVITY}` : ''}` }}
            pricePreText={`${isActivity ? t({id: "activity_cost", message: "Activity Cost"}) : t({id: "restaurant_cost", message: "Restaurant Cost"})} :`}
            price={entry.price}
        >
            <div>
                <Trans id="on_day">On day</Trans> {entry.dayNr} ({formatCartElementDate(entry.date)})
            </div>
            <div className="mt-2">
                {isActivity
                    ? <Trans id="x_guests_at_time">
                        <div className="mb-1">
                            <Plural value={nrGuests} one="# guest" other="# guests" />
                        </div>
                        <div>
                            at <span className="font-bold">{entry.time}</span>
                        </div>
                    </Trans>
                    : <Trans id="table_for_x_people">
                        <div className="mb-1">
                            Table for <Plural value={nrGuests} one="# person" other="# people" />
                        </div>
                        <div>
                            at <span className="font-bold">{entry.time}</span>
                        </div>
                    </Trans>
                }
            </div>
        </CartElementCheckout>
    )
}

export default CartElementTacCheckout;